/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const resolver =
  (context: any, event: any) => (callback: any, onEvent: any) => {

    if (event?.data?.value) {
      context.table = event?.data?.value;
    } 

    onEvent((e: any) => {
      if(context.table){
        callback('SUCCESS', event?.data?.value);
      }
      else{
        callback('ERROR');
      }
    
    });
  };
